import { render, staticRenderFns } from "./SparkComments.vue?vue&type=template&id=25beeed9&scoped=true&"
import script from "./SparkComments.vue?vue&type=script&lang=ts&"
export * from "./SparkComments.vue?vue&type=script&lang=ts&"
import style0 from "./SparkComments.vue?vue&type=style&index=0&id=25beeed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25beeed9",
  null
  
)

export default component.exports